var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2709_01052"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2709_01052)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,21,-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.901899999999998,14.2299C32.1807,14.7129,31.8321,15.3166,31.2744,15.3166L18.725588,15.3166C18.167862,15.3166,17.819284,14.7129,18.0981465,14.2299L24.37256,3.362253C24.65142,2.879249,25.34858,2.879249,25.62744,3.362253L31.901899999999998,14.2299Z",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6ee6bbcc0f3e212c709afb1ba4bcbab4.svg";
export { ForwardRef as ReactComponent };